// class ShareButton extends HTMLElement {
//   constructor() {
//     super();
//     this.button = this.querySelector("button");
//     this.urlInput = this.querySelector("input");
//     this.tooltip = this.querySelector(".tooltip");
//     this.button.addEventListener("click", () => this.handleClick());
//   }
//   handleClick() {
//     const url = this.urlInput.value;
//     if (navigator.share) {
//       navigator.share({ url, title: document.title }).catch(() => {
//         this.copyToClipboard(url);
//       });
//     } else {
//       this.copyToClipboard(url);
//     }
//   }
//   copyToClipboard(url) {
//     navigator.clipboard
//       .writeText(url)
//       .then(() => {
//         this.showTooltip();
//       })
//       .catch((err) => {
//         console.error("Failed to copy URL:", err);
//       });
//   }
//   showTooltip() {
//     if (!this.tooltip) return;
//     this.tooltip.classList.add("show");
//     this.tooltip.classList.remove("hidden");
//     setTimeout(() => {
//       this.tooltip.classList.remove("show");
//       this.tooltip.classList.add("hidden");
//     }, 2000);
//   }
// }
// customElements.define("share-button", ShareButton);

// Register `share-button` only if it isn't registered yet.
if (!customElements.get("share-button")) {
  customElements.define(
    "share-button",
    class extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button");
        this.urlInput = this.querySelector("input");
        this.tooltip = this.querySelector(".tooltip");
        this.button?.addEventListener("click", () => this.handleClick());
      }
      handleClick() {
        const url = this.urlInput?.value;
        if (navigator.share) {
          navigator.share({ url, title: document.title }).catch(() => {
            this.copyToClipboard(url);
          });
        } else {
          this.copyToClipboard(url);
        }
      }
      copyToClipboard(url) {
        navigator.clipboard
          ?.writeText(url)
          .then(() => {
            this.showTooltip();
          })
          .catch((err) => {
            console.error("Failed to copy URL:", err);
          });
      }
      showTooltip() {
        if (!this.tooltip) return;
        this.tooltip.classList.add("show");
        this.tooltip.classList.remove("hidden");
        setTimeout(() => {
          this.tooltip.classList.remove("show");
          this.tooltip.classList.add("hidden");
        }, 2000);
      }
    }
  );
}
